module.exports = __webpack_public_path__ + "img/squats.8162aa40.png";